import { api } from './api';

import { UserResponse, GetUsersParams, UserDetails, User, UserLogsResponse, GetUserLogsParams } from '@/types';

export const userApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllUsers: builder.query<UserResponse, GetUsersParams>({
      query: (params) => ({
        url: '/v2/users',
        params,
      }),
      providesTags: [{ type: 'User' }],
    }),
    getUserDetails: builder.query<UserDetails, string>({
      query: (userId) => ({
        url: `/v2/users/${userId}`,
        method: 'GET',
      }),
      providesTags: (result, error, userId) => [{ type: 'User', id: userId }],
    }),
    updateUserDetails: builder.mutation<
      UserDetails,
      { userId: string; data: Partial<UserDetails> }
    >({
      query: ({ userId, data }) => ({
        url: `/v2/users/${userId}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (result, error, { userId }) => [
        { type: 'User', id: userId },
        { type: 'User' },
      ],
    }),
    createUserDetails: builder.mutation<UserDetails, { data: Partial<User> }>({
      query: ({ data }) => ({
        url: '/v2/users',
        method: 'POST',
        body: data,
      }),
    }),
    getUserLogs: builder.query<UserLogsResponse, GetUserLogsParams>({
      query: (params) => ({
        url: '/v2/logs',
        params,
      }),
    }),
  }),
});

export const {
  useGetAllUsersQuery,
  useGetUserDetailsQuery,
  useUpdateUserDetailsMutation,
  useCreateUserDetailsMutation,
  useGetUserLogsQuery,
} = userApi;
